// sof-coverage — N gift icons + "Wraps about N gifts", updates on size change.
// Count derived from the size string (robust to "6 ft Roll" / "6ft Roll" etc).
(function () {
  var GIFT = '<svg class="sof-coverage__gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S11 3 8.5 3 6 5 6 5s.5 2 6 2zM12 7s1-4 3.5-4S18 5 18 5s-.5 2-6 2z"/></svg>';
  function countFor(sz) { if (/15/.test(sz)) return 10; if (/6/.test(sz)) return 4; return 0; }
  function currentSize() {
    var r = document.querySelector('variant-selects input[type="radio"]:checked');
    if (r && r.value) return r.value.trim();
    var s = document.querySelector('variant-selects select');
    if (s && s.value) return s.value.trim();
    return "";
  }
  function update() {
    var n = countFor(currentSize()); if (!n) return;
    var icons = document.querySelector("[data-sof-coverage-icons]");
    var text = document.querySelector("[data-sof-coverage-text]");
    if (icons) icons.innerHTML = new Array(n + 1).join(GIFT);
    if (text) text.textContent = "Wraps about " + n + " gifts";
  }
  function init() {
    update();
    document.addEventListener("change", function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest("variant-selects")) setTimeout(update, 20);
    });
    document.addEventListener("shopify:section:load", update);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
